import React from "react";
import axios from "axios";
import Conf from "./Conf";
import Navbar from "./components/Navbar";
import PageHead from "./components/PageHead";
// import {Grid} from '@material-ui/core';
import { goLogin, getPermission, getStampTime } from "./js/main";
import ReceiptIcon from "@material-ui/icons/Receipt";
import PhonelinkRingIcon from "@material-ui/icons/PhonelinkRing";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import Grid from "@material-ui/core/Grid";
import RemoveIcon from "@material-ui/icons/Remove";

const current_path = Conf.frontendURL + "create";
const page_title = "ออกใบเสร็จ";
export default class CreateBill extends React.Component {
  state = {
    cookie: null,
    account: [],
    form: {
      app_id: "50",
      debtor_name: "",
      patron_code: "",
      debtor_idx: "",
      debtor_vat: "",
      debtor_address: "",
      debtor_email: "",
      description: "",
      callback_url: Conf.digitalpayBackend + "paid",
    },
    item: {
      account: "",
      chart_code: "",
      account_code: "",
      amount: 0,
      account_name: "",
      biller_name: "",
      description: "",
    },
    total: 0,
    details: [],
    old_bill: null,
    loading: false,
  };
  componentDidMount() {
    this.getAuth();
  }
  async getAuth() {
    var cookie = localStorage.getItem(Conf.cookieName);
    cookie = JSON.parse(cookie);
    if (cookie && cookie.token) {
      var auth = await getPermission(cookie.token);
      if (auth === false) goLogin(current_path);
      else {
        var account = await this.getAccount();
        this.setState({ profile: auth.profile, cookie, account }, () => {
          if (this.props.match.params.bill_id) {
            this.copyOldBill(this.props.match.params.bill_id);
          } else if (Conf.on_dev === true) {
            this.importTestValue();
          }
        });
      }
    } else goLogin(current_path);
  }
  async copyOldBill(bill_id) {
    var cookie = localStorage.getItem(Conf.cookieName);
    cookie = JSON.parse(cookie);
    let query = { bill_id: bill_id };
    query = JSON.stringify(query);
    var oldBill = await axios.post(
      Conf.digitalpayBackend + "bill",
      { query: query },
      {
        headers: { Authorization: cookie.token },
      }
    );
    if (oldBill.data && oldBill.data.bills && oldBill.data.bills.length > 0) {
      console.log(oldBill.data.bills[0]);
      oldBill = oldBill.data.bills[0];
      var invoice = await axios.get(
        Conf.digitalpayBackend + "invoice/" + oldBill.invoice_id._id,
        {
          headers: { Authorization: cookie.token },
        }
      );
      invoice = invoice.data;
      var { form, profile } = this.state;
      form.debtor_name = invoice.debtor_name;
      form.patron_code = "";
      form.debtor_idx = invoice.debtor_idx;
      form.debtor_vat = invoice.debtor_vat;
      form.debtor_address = invoice.debtor_address;
      form.debtor_email = invoice.debtor_email;
      form.patron_code = invoice.debtor_patron_code;
      form.description = invoice.description;
      form.bill_id = oldBill.bill_id;
      form._id = oldBill._id;
      form.bill_year = oldBill.bill_year;
      form.bill_no = oldBill.bill_no;

      form.payerName = oldBill.payerName;
      form.payerAccountName = oldBill.payerAccountName;
      form.transactionDateandTime = oldBill.transactionDateandTime;
      form.billPaymentRef1 = oldBill.billPaymentRef1;
      form.billPaymentRef2 = oldBill.billPaymentRef2;
      form.currencyCode = oldBill.currencyCode;
      form.channelCode = oldBill.channelCode;
      form.transactionType = oldBill.transactionType;
      form.old_invoice = oldBill.invoice_id._id;
      form.operator = {
        name: profile.NameTha + " " + profile.SurNameTha,
        usn: profile.usn,
      };
      console.log(invoice.debtor_email, this.state.profile);
      this.setState(
        { form, details: invoice.details, old_bill: oldBill },
        async () => {
          var total = await this.calTotal();
          this.setState({ total });
        }
      );
    }
  }
  importTestValue() {
    var { form, item } = this.state;
    form.debtor_name = "นายปราชญ์ สงวนศักดิ์";
    // form.patron_code = "20001900142096";
    form.patron_code = "20001990044046";
    form.debtor_idx = "3120100603762";
    form.debtor_vat = "3120100603762";
    form.debtor_address = "สำนักหอสมุด มหาวิทยาลัยเชียงใหม่";
    form.debtor_email = "pratchaya.s@cmu.ac.th";
    form.description = "[TEST] ทดสอบ";

    item.account = "4010704000001-4070401";
    item.account_code = "4010704000001";
    item.account_name = "รายได้จากค่าปรับ";
    item.amount = 1;
    item.biller_name = "รายได้จากค่าปรับ";
    item.chart_code = "4070401";
    item.description = "ทดสอบ";
    this.setState({ form, item });
  }
  getAccount() {
    return new Promise((resolve) => {
      var cookie = localStorage.getItem(Conf.cookieName);
      cookie = JSON.parse(cookie);
      axios
        .get(Conf.backendURL + "account", {
          headers: { Authorization: cookie.token },
        })
        .then((res) => {
          if (res.data.error) {
            alert(res.data.error);
            goLogin(current_path);
          } else {
            res.data.sort(function (a, b) {
              return b.priority - a.priority;
            });
            resolve(res.data.filter((j) => j.disabled !== true));
          }
        });
    });
  }
  changeAccount(e) {
    var accountVal = e.target.value;
    var arr = accountVal.split("-");
    var { item, account } = this.state;
    var i = account.findIndex(
      (j) => j.account_code === arr[0] && j.chart_code === arr[1]
    );
    if (i > -1) {
      item.account = accountVal;
      item.chart_code = arr[1];
      item.account_code = arr[0];
      item.account_name = account[i].account_name;
      item.biller_name = account[i].biller_name;
      this.setState({ item }, () => document.getElementById("amount").select());
    }
  }
  changeItem(e) {
    var id = e.target.id;
    var { item } = this.state;
    if (id === "amount") item[id] = parseFloat(e.target.value);
    else item[id] = e.target.value;
    this.setState({ item });
  }
  changeForm(e) {
    var id = e.target.id;
    var { form } = this.state;
    if (id === "remark") id = "description";
    form[id] = e.target.value;
    this.setState({ form });
  }
  getPatronEmail() {
    return new Promise(async (resolve) => {
      var { form } = this.state;
      var result = await axios.post("https://cloud-3003.lib.cmu.ac.th/patron", {
        query: { patron_code: form.patron_code },
      });
      console.log(result);
      var email = "";
      if (result.data && result.data[0]) {
        if (result.data[0].email) email = result.data[0].email;
        else if (result.data[0].cmu_email) email = result.data[0].cmu_email;
      }
      resolve(email);
    });
  }
  async searchPatron(e) {
    if (e.key === "Enter") {
      var { form } = this.state;
      form.debtor_email = await this.getPatronEmail();
      axios
        .post(
          "https://apps.library.cmu.ac.th/cloudplatform/sip2/v2/holding/index.php",
          { patronCode: form.patron_code }
        )
        .then((res) => {
          if (
            res.data.AE &&
            res.data.AE.value &&
            res.data.AE.value !== "No Name"
          ) {
            form.debtor_name = res.data.AE.value;
            // Auto add item
            if (
              res.data.BV &&
              res.data.BV.value &&
              parseFloat(res.data.BV.value) > 0
            ) {
              var { account, details } = this.state;
              let i = account.findIndex(
                (j) => j.account_code === Conf.fines_account_code
              );
              let j = details.findIndex(
                (j) => j.account_code === Conf.fines_account_code
              );
              if (i > -1 && j < 0) {
                let item = JSON.parse(JSON.stringify(account[i]));
                // this.setState({ item }, () => this.saveItem());
                details.push({
                  account: item.account_code + "-" + item.chart_code,
                  account_code: item.account_code,
                  account_name: item.account_name,
                  amount: parseFloat(res.data.BV.value),
                  biller_name: item.biller_name,
                  chart_code: item.chart_code,
                });
              }
            }
            this.setState({ form });
          }
        });
    }
  }
  async saveItem() {
    var { item, details } = this.state;
    if (item.account === "") alert("Please fill completed information");
    else {
      var addItem = JSON.parse(JSON.stringify(item));
      item = await this.resetItem();
      details.push(addItem);
      console.log(details);
      var total = await this.calTotal();
      console.log(total);
      this.setState({ item, details, total });
    }
  }
  calTotal() {
    return new Promise(async (resolve) => {
      var total = await this.state.details.reduce(
        (accumulator, currentValue) => accumulator + currentValue.amount,
        0
      );
      resolve(total);
    });
  }
  resetItem() {
    return new Promise((resolve) => {
      resolve({
        account: "",
        chart_code: "",
        account_code: "",
        amount: 0,
        account_name: "",
        biller_name: "",
        description: "",
      });
    });
  }
  async createInvoice(status) {
    var { details, form, profile } = this.state;
    var sendDetail = await details.map((detail) => {
      return {
        chart_code: detail.chart_code,
        account_code: detail.account_code,
        amount: detail.amount,
        description: detail.description,
      };
    });
    var url = Conf.backendURL + "invoice";
    var send = JSON.parse(JSON.stringify(form));
    send.details = sendDetail;
    send.debtor_patron_code = form.patron_code;
    if (send._id) {
      delete send._id;
    }
    var chk = await this.checkBeforeCreateInvoice(send);
    if (chk === true) {
      send.operator = {
        name: profile.PrenameTha + profile.NameTha + " " + profile.SurNameTha,
        usn: profile.usn,
      };
      send.pay_type=status;
      axios.put(url, send).then((res) => {
        if (form._id) {
          this.replaceBill(res.data._id);
        } else if (status === "cash" || status === "cash_tranfer") {
          window.location = Conf.frontendURL + "pay/" + res.data.invoice_id;
        } else {
          this.props.history.push(
            process.env.PUBLIC_URL + "/tranfer/" + res.data.invoice_id
          );
        }
        // window.location = Conf.frontendURL + "tranfer/" + res.data.invoice_id;
      });
    }
  }
  checkBeforeCreateInvoice(send) {
    return new Promise((resolve) => {
      if (send.debtor_name === "" || send.details.length < 1) {
        alert("Please fill completed information");
        resolve(false);
      } else resolve(true);
    });
  }
  removeDetail(detail) {
    let { details } = this.state;
    details = details.filter((j) => j !== detail);
    this.setState({ details }, async () => {
      let total = await this.calTotal();
      this.setState({ total });
    });
  }
  async replaceBill(invoice_id) {
    var { form, profile, old_bill } = this.state;
    var cookie = localStorage.getItem(Conf.cookieName);
    cookie = JSON.parse(cookie);
    var invoice = await axios.get(Conf.backendURL + "invoice/" + invoice_id);
    invoice = invoice.data;
    var send = {};
    if (form.transactionType === "Pay by Cash") {
      var dt = await getStampTime();
      dt = dt.iso_date + "T" + dt.host_time;
      var transactionDateandTime = dt + "+07:00";

      send = {
        invoice_id: invoice._id,
        payerName: invoice.debtor_name,
        amount: invoice.amount,
        transactionDateandTime: transactionDateandTime,
        transactionType: "Pay by Cash",
        description: "ชำระผ่านระบบ CMUL Digital Payment",
        replace_id: old_bill._id,
        replace_bill_no: old_bill.bill_id,
        payer: {
          name: invoice.debtor_name,
          idx: invoice.debtor_idx,
          vat: invoice.debtor_vat,
          addr: invoice.debtor_address,
          email: invoice.debtor_email,
        },
        operator: {
          name: profile.PrenameTha + profile.NameTha + " " + profile.SurNameTha,
          usn: profile.usn,
        },
      };
      console.log("CASH");
      axios
        .post(Conf.digitalpayBackend + "paid/cash", send, {
          headers: { Authorization: cookie.token },
        })
        .then(async (res) => {
          this.props.history.push(
            process.env.PUBLIC_URL + "/tranfer/" + invoice.invoice_id
          );
        });
    } else {
      send = {
        replace_id: old_bill._id,
        invoice_id: invoice._id,
        operator: {
          name: profile.PrenameTha + profile.NameTha + " " + profile.SurNameTha,
          usn: profile.usn,
        },
        payer_name: invoice.debtor_name,

        idx: invoice.debtor_idx,
        vat: invoice.debtor_vat,
        addr: invoice.debtor_address,
        email: invoice.debtor_email,
        description: "ชำระผ่านระบบ CMUL Digital Payment",
      };
      axios
        .put(Conf.digitalpayBackend + "bill/replace/tranfer", send, {
          headers: { Authorization: cookie.token },
        })
        .then(async (res) => {
          this.props.history.push(
            process.env.PUBLIC_URL + "/tranfer/" + invoice.invoice_id
          );
        });
    }

    /*
    
      var id = invoice_id;
      axios.get(Conf.backendURL + "invoice/" + id).then((res) => {
        resolve(res.data);
      });
    var dt = await getStampTime();
    dt = dt.iso_date + "T" + dt.host_time;
    var transactionDateandTime = dt + "+07:00";

    var { invoice, profile } = this.state;
    var send = {
      invoice_id: invoice._id,
      payerName: invoice.debtor_name,
      amount: invoice.amount,
      transactionDateandTime: transactionDateandTime,
      transactionType: "Pay by Cash",
      description: "ชำระผ่านระบบ CMUL Digital Payment",
      payer: {
        name: invoice.debtor_name,
        idx: invoice.debtor_idx,
        vat: invoice.debtor_vat,
        addr: invoice.debtor_address,
        email: invoice.debtor_email,
      },
      operator: {
        name: profile.PrenameTha + profile.NameTha + " " + profile.SurNameTha,
        usn: profile.Email,
      },
    };
    var cookie = localStorage.getItem(Conf.cookieName);
    cookie = JSON.parse(cookie);
    axios
      .post(Conf.digitalpayBackend + "paid/cash", send, {
        headers: { Authorization: cookie.token },
      })
      .then(async (res) => {
        console.log(res.data);
        let otp = await this.getOTP(res.data.bill_id);
        this.setState({ is_load: false, paid: true, otp });
      });
      */
  }
  replaceInvoice() {
    let { form /* , old_bill  */ } = this.state;
    let pay_type = "cash";
    if (form.transactionType !== "Pay by Cash") pay_type = "tranfer";
    this.setState({ loading: true }, () => {
      this.createInvoice(pay_type);
    });
    // console.log(old_bill);

    /*
    let send = JSON.parse(JSON.stringify(form));

    send.replace_id = form._id;
    send.replace_bill_no = form.bill_id;
    send.details = details;
    send.debtor_patron_code = form.patron_code;
    send.amount = total;
    delete send._id;
    delete send.bill_id;

    var cookie = localStorage.getItem(Conf.cookieName);
    cookie = JSON.parse(cookie);
    axios
      .put(Conf.digitalpayBackend + "bill/replace", send, {
        headers: { Authorization: cookie.token },
      })
      .then((res) => {
        if (res.data.error) {
          alert(res.data.error);
        } else {
          alert("Save Completed");
          this.props.history.push(process.env.PUBLIC_URL + "/report");
        }
      });
      */
  }
  render() {
    const { profile, account, item, details, form, total, loading } =
      this.state;
    const styles = {
      inputLabel: {
        color: "#000",
        fontSize: "1.2em",
        fontWeight: "bold !important",
      },
    };
    return (
      <>
        {profile && (
          <div>
            <Navbar />
            <main className="content">
              <PageHead
                icon={<ReceiptIcon style={{ fontSize: "2rem" }} />}
                title={page_title}
                profile={profile}
              />
              <Grid container spacing={2}>
                <Grid item xs={6} md={3} lg={3}>
                  <TextField
                    label="Payer Name"
                    fullWidth
                    onChange={(e) => this.changeForm(e)}
                    value={form.debtor_name}
                    id="debtor_name"
                    placeholder="ชื่อผู้ชำระเงิน"
                    variant="outlined"
                    size="small"
                    InputLabelProps={{
                      shrink: true,
                      style: styles.inputLabel,
                    }}
                  />
                </Grid>
                <Grid item xs={6} md={3} lg={3}>
                  <TextField
                    label="Patron Barcode"
                    fullWidth
                    onChange={(e) => this.changeForm(e)}
                    onKeyUp={(e) => this.searchPatron(e)}
                    value={form.patron_code}
                    id="patron_code"
                    placeholder="หมายเลขสมาชิกห้องสมุด"
                    variant="outlined"
                    size="small"
                    InputLabelProps={{ shrink: true, style: styles.inputLabel }}
                  />
                </Grid>
                <Grid item xs={6} md={3} lg={3}>
                  <TextField
                    label="Tax ID / ID Card Number"
                    fullWidth
                    onChange={(e) => this.changeForm(e)}
                    value={form.debtor_idx}
                    id="debtor_idx"
                    placeholder="เลขประจำตัวผู้เสียภาษี/หมายเลขบัตรประชาชน"
                    variant="outlined"
                    size="small"
                    InputLabelProps={{ shrink: true, style: styles.inputLabel }}
                  />
                </Grid>
                {/* <Grid item xs={12} md={4}>
                  <TextField
                    label="VAT Number"
                    fullWidth
                    onChange={(e) => this.changeForm(e)}
                    value={form.debtor_vat}
                    id="debtor_vat"
                    placeholder="หมายเลขผู้เสียภาษี"
                    variant="outlined"
                    size="small"
                    InputLabelProps={{ shrink: true, style: styles.inputLabel }}
                  />
                </Grid> */}
                <Grid item xs={6} md={3} lg={3}>
                  <TextField
                    label="e-Mail"
                    fullWidth
                    onChange={(e) => this.changeForm(e)}
                    value={form.debtor_email}
                    id="debtor_email"
                    placeholder="อีเมลสำหรับจัดส่งใบเสร็จ"
                    variant="outlined"
                    size="small"
                    InputLabelProps={{ shrink: true, style: styles.inputLabel }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label="Address"
                    fullWidth
                    onChange={(e) => this.changeForm(e)}
                    value={form.debtor_address}
                    id="debtor_address"
                    placeholder="ที่อยู่"
                    variant="outlined"
                    size="small"
                    InputLabelProps={{ shrink: true, style: styles.inputLabel }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label="Remark"
                    fullWidth
                    onChange={(e) => this.changeForm(e)}
                    value={form.description}
                    id="remark"
                    placeholder="หมายเหตุ"
                    variant="outlined"
                    size="small"
                    InputLabelProps={{ shrink: true, style: styles.inputLabel }}
                  />
                </Grid>
              </Grid>
              <TableContainer style={{ marginTop: "10px" }}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell style={{ width: "80px" }}>No.</TableCell>
                      <TableCell colSpan="2">Descriptions</TableCell>
                      <TableCell style={{ width: "200px" }}>Amount</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell className="tdCenter">+</TableCell>
                      <TableCell
                        className="tdCenter"
                        style={{ padding: "3px 3px" }}
                        colSpan="2"
                      >
                        <div style={{ paddingBottom: "2px" }}>
                          <FormControl
                            variant="outlined"
                            size="small"
                            fullWidth
                          >
                            <Select
                              native
                              value={item.account}
                              onChange={(e) => this.changeAccount(e)}
                              fullWidth
                              inputProps={{
                                id: "rowAccount",
                              }}
                            >
                              <option value=""></option>
                              {account.map((acc) => (
                                <option
                                  key={acc._id}
                                  value={`${acc.account_code}-${acc.chart_code}`}
                                >
                                  {acc.biller_name}
                                </option>
                              ))}
                            </Select>
                          </FormControl>
                        </div>
                        <div>
                          <TextField
                            fullWidth
                            onChange={(e) => this.changeItem(e)}
                            value={item.description}
                            id="description"
                            placeholder="Detail"
                            variant="outlined"
                            size="small"
                          />
                        </div>
                      </TableCell>
                      <TableCell
                        className="tdCenter"
                        style={{ padding: "3px 3px", verticalAlign: "top" }}
                      >
                        <div style={{ paddingBottom: "4px" }}>
                          <TextField
                            fullWidth
                            onChange={(e) => this.changeItem(e)}
                            id="amount"
                            value={item.amount}
                            placeholder="Amount"
                            variant="outlined"
                            size="small"
                            inputProps={{
                              style: { textAlign: "center" },
                              type: "number",
                            }}
                          />
                        </div>
                        <div>
                          <Button
                            variant="contained"
                            fullWidth
                            color="primary"
                            onClick={() => this.saveItem()}
                          >
                            Add Item
                          </Button>
                        </div>
                      </TableCell>
                    </TableRow>
                    {details.map((detail, key) => (
                      <TableRow key={key}>
                        <TableCell
                          className="tdCenter"
                          style={{ verticalAlign: "top" }}
                        >
                          {key + 1}
                        </TableCell>
                        <TableCell
                          className="tdCenter"
                          style={{ width: "150px", verticalAlign: "top" }}
                        >
                          {detail.account_code}
                        </TableCell>
                        <TableCell>
                          <div style={{ lineHeight: "23px" }}>
                            <div style={{ float: "left" }}>
                              <IconButton
                                color="secondary"
                                component="span"
                                style={{
                                  padding: "0px 0px",
                                  marginRight: "10px",
                                }}
                                onClick={() => this.removeDetail(detail)}
                              >
                                <RemoveIcon />
                              </IconButton>
                            </div>
                            {detail.biller_name}
                          </div>
                          {detail.description && detail.description !== "" && (
                            <div style={{ paddingLeft: "30px" }}>
                              ({detail.description})
                            </div>
                          )}
                        </TableCell>
                        <TableCell
                          style={{ textAlign: "right", verticalAlign: "top" }}
                        >
                          {detail.amount.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                          })}
                        </TableCell>
                      </TableRow>
                    ))}
                    {details.length > 0 && (
                      <TableRow>
                        <TableCell colSpan="3" style={{ textAlign: "right" }}>
                          <span style={{ fontWeight: 400 }}>Total</span>
                        </TableCell>
                        <TableCell
                          style={{
                            textAlign: "right",
                            verticalAlign: "top",
                          }}
                        >
                          <span style={{ fontWeight: 400 }}>
                            {total.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                            })}
                          </span>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              {this.props.match.params.bill_id ? (
                <div style={{ marginTop: "20px", textAlign: "right" }}>
                  <Button
                    disabled={loading}
                    variant="contained"
                    color="primary"
                    size="large"
                    style={{
                      width: "250px",
                    }}
                    onClick={() => this.replaceInvoice()}
                  >
                    Save New Bill
                  </Button>
                </div>
              ) : (
                <div style={{ marginTop: "20px" }}>
                  {/* <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    style={{
                      marginRight: "20px",
                      float: "left",
                      width: "250px",
                    }}
                    startIcon={
                      <PhonelinkRingIcon style={{ fontSize: "2rem" }} />
                    }
                    onClick={() => this.createInvoice("tranfer")}
                  >
                    Tranfer
                  </Button> */}
                  <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    style={{
                      marginRight: "20px",
                      float: "left",
                      width: "250px",
                    }}
                    startIcon={
                      <PhonelinkRingIcon style={{ fontSize: "2rem" }} />
                    }
                    onClick={() => this.createInvoice("cash_tranfer")}
                  >
                    Tranfer
                  </Button>
                  <Button
                    variant="contained"
                    color="inherit"
                    style={{
                      background: "#6b6",
                      color: "#fff",
                      float: "right",
                      width: "250px",
                    }}
                    size="large"
                    startIcon={<AttachMoneyIcon style={{ fontSize: "2rem" }} />}
                    onClick={() => this.createInvoice("cash")}
                  >
                    Cash
                  </Button>
                </div>
              )}
            </main>
          </div>
        )}
      </>
    );
  }
}
